export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    SENDMAIL_REQUEST: 'USERS_SENDMAIL_REQUEST',
    SENDMAIL_SUCCESS: 'USERS_SENDMAIL_SUCCESS',
    SENDMAIL_FAILURE: 'USERS_SENDMAIL_FAILURE',

    CHECKTOKEN_REQUEST: 'USERS_CHECKTOKEN_REQUEST',
    CHECKTOKEN_SUCCESS: 'USERS_CHECKTOKEN_SUCCESS',
    CHECKTOKEN_FAILURE: 'USERS_CHECKTOKEN_FAILURE',

    CHANGEPASSWORD_REQUEST: 'USERS_CHANGEPASSWORD__REQUEST',
    CHANGEPASSWORD_SUCCESS: 'USERS_CHANGEPASSWORD__SUCCESS',
    CHANGEPASSWORD_FAILURE: 'USERS_CHANGEPASSWORD__FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    
    GETPROFILE_REQUIEST:'GET_PROFILE_REQUIEST',
    GETPROFILE_SUCCESS:'GET_PROFILE_SUCCESS',
    GETPROFILE_FAILURE:'GET_PROFILE_FAILURE',

    UPDATEPROFILE_REQUIEST:'UPDATE_PROFILE_REQUIEST',
    UPDATEPROFILE_SUCCESS:'UPDATE_PROFILE_SUCCESS',
    UPDATEPROFILE_FAILURE:'UPDATE_PROFILE_FAILURE',

};